<template>
    <section>

        <!-- 如果还有子目录 -->
        <van-list
            v-show="categories.length>0"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="getList"
        >
            <van-cell
                v-for="item in categories"
                :key="item.id"
                :title="item.name"
                is-link
                clickable
                :to="'child-categories?id=' + item.id"
            />
        </van-list>

        <!-- 没有子目录 -->
        <categories-child v-if="finished && categories.length === 0" />
    </section>
</template>

<script>
import { Cell, List } from "vant";
import categoriesChild from "./categoriesChild.vue";
import ClientApi from '@/assets/js/clientApi.js'
export default {
    components: {
        "van-list": List,
        "van-cell": Cell,
        categoriesChild
    },
    data () {
        return {
            loading: false,
            finished: false,
            page: 1,
            id: this.$route.query.id,
            categories: []
        };
    },
    created () {
        this.getList()
        this.$route.query.title && ClientApi.getApi('setTitleJS', this.$route.query.title)
    },
    methods: {
        async getList () {
            try {
                let data = await this.getCategories();
                if (!data || data.length <= 0) {
                    this.loading = false;
                    this.finished = true;
                    return;
                }
                // 加载状态结束
                this.loading = false;
                this.categories = this.categories.concat(data);
                if (data.length < 10) {
                    this.finished = true;
                }
            } catch (error) {
                this.loading = false;
                this.finished = true;
            }
        },
        async getCategories () {
            let data = await this.$http.get(
                "/wp-json/wp/v2/categories?parent=" + this.id + "&orderby=description&order=desc" + "&page=" + this.page++
            );
            return data;
        }
    }
};
</script>

